(ns motorsaif.web.pages.feed
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.string :as mstr :refer [format]]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.components.request-listing :as listing]
   [motorsaif.request-utils :as req-utils]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]))

#_(dispatch [:assoc-data :feed-filters [{:make "Lexus"
                                         :model "IS-Series"
                                         :type :repair
                                         :year {:min 2001
                                                :max 2010}}
                                        {:type :repair
                                         :make "Lexus"
                                         :model "IS-Series"}
                                        {:make "Lexus"}
                                        {:make "Lexus"
                                         :model "IS-Series"
                                         :type :repair
                                         :tag 17592186045437
                                         :year {:min 2001}}]])

;; #_[:div.search-section
;;          [:div.search-wrapper
;;           [:i.fas.fa-search]
;;           [:input {:type "text"
;;                    :placeholder "Search..."
;;                    :value @*search
;;                    :on-change #(reset! *search (.. % -target -value))}]]
;;          [:button.filter-btn
;;           [:i.fas.fa-filter]]]
(defn status-filter []
  (let [*status (r/atom :open)
        *search (r/atom "")]
    (fn []
      [:div.status-filter
       [c/tabs-section
        {:tabs [{:key :open :content "Open"}
                {:key :resolved :content "Resolved"}]
         :active-tab @*status
         :on-tab-click #(reset! *status %)}]
       ])))

(defn filters [{:keys [on-save filters start-open?]}]
  (let [*filters (r/atom filters)
        add-new-fn (fn [data]
                     (dispatch [:set-modal nil])
                     (when data
                       (swap! *filters (fnil conj []) data)))
        *added-shown? (r/atom start-open?)
        _ (add-watch *filters :save-watch
                     (fn [_ _ _ new-state]
                       (on-save new-state)))
        show-modal-fn (fn []
                        (dispatch [:assoc-data :modal
                                   {:renderer
                                    (fn [] [c/services-modal {:init-data {}
                                                              :on-save add-new-fn}])}]))]
    (fn []
      (let [filters @*filters]
        [:div.feed-filters
         (if (seq filters)
           [:div.has-filters
            [:div.flex
             [:button.btn.show-added
              {:type "button"
               :on-click #(swap! *added-shown? not)}
              [:span.txt
               [:span.count (count filters)]
               (str (mstr/pluralize :word " filter" :count (count filters)) " added")]
              (if @*added-shown?
                [:i.fas.fa-caret-up]
                [:i.fas.fa-caret-down])]

             [:button.btn.primary.add-filter
              {:type "button"
               :on-click show-modal-fn}
              [:i.fal.fa-filter-list]
              (tr :general.filters)]]

            (when @*added-shown?
              (into [:div.filter-list]
                    (map-indexed #(c/service-filter
                                   {:idx %1
                                    :data %2
                                    :*filters *filters}) filters)))]

           [:div.no-filters
            [:div.flex
             [:span (tr :page.feed.all-requests)]
             [:button.btn.primary.add-filter
              {:type "button"
               :on-click show-modal-fn}
              [:i.fal.fa-filter-list]
              (tr :general.services "Services")]]])]))))

(defn root [{:keys [after-mount]}]
  (r/create-class
    {:component-did-mount after-mount
     :reagent-render
     (fn []
       (let [{:keys [path-params]} @(rf/subscribe [:route/data])
             *requests (subscribe [:requests])
             *filters (subscribe [:feed-filters])
             requests (req-utils/filter-requests @*filters @*requests)]
         [:<>
          [c/header
           (tr :page.feed/header)]
          [:div#content.container-sm
           ;; [status-filter]
           #_[filters {:filters @*filters
                     :start-open? (not (seq requests))
                     :on-save #(dispatch [:assoc-data :feed-filters %])}]
           (if (seq requests)
             (into [:div]
                   (map
                    listing/request-listing
                    (reverse (sort-by :date-time/created requests))))
             [:div [:h2
                    (tr :page.feed/no-results)]])]]))}))
